// store.js
import { createStore, combineReducers } from 'redux';
import patientsReducer from '../Reducers/patientsListReducers';
import panelReducers from '../Reducers/panelsListsReducers';
import couponsReducers from '../Reducers/couponReducers'
const rootReducer = combineReducers({
    patients: patientsReducer,
    panels:panelReducers,
    coupons:couponsReducers
    // Add more reducers if needed
});

const store = createStore(rootReducer);

export default store;
